
        import { insertLogo } from '/js/ui/logos.js';
        import { sendGAEvent, GA_EVENT_CATEGORIES } from '/js/analytics.js';

        // Mobile enhancements
        import '/js/ui/mobile.js';

        // Tutorial Modal Logic
        const tutorialModal = document.getElementById('tutorialModal');
        const tutorialVideo = document.getElementById('tutorialVideo');
        const closeTutorialButton = tutorialModal.querySelector('.tutorial-close-btn');
        const skipTutorialButton = tutorialModal.querySelector('.tutorial-skip-btn');
        const tutorialStorageKey = 'vidia-tutorial-seen';

        let backgroundVideos = []; // To store references to background videos
        let tutorialVideoDuration = 0;
        let tutorialCompletedNaturally = false; // Flag to check if video ended on its own

        function openTutorial() {
            // Pause background videos
            backgroundVideos.forEach(video => {
                if (video && typeof video.pause === 'function' && !video.paused) {
                    video.dataset.wasPlaying = 'true'; // Mark that it should resume
                    video.pause();
                }
            });

            tutorialModal.style.display = 'flex'; // Set display to flex before animation
            setTimeout(() => { // Timeout to allow display property to apply before transition
                tutorialModal.classList.add('visible');
                document.body.style.overflow = 'hidden'; // Prevent scrolling while modal is open
            }, 10); // Small delay
            
            tutorialVideo.currentTime = 0;
            tutorialCompletedNaturally = false; // Reset flag

            tutorialVideo.play().then(() => {
                if (tutorialVideo.duration && !isNaN(tutorialVideo.duration)) {
                    tutorialVideoDuration = tutorialVideo.duration;
                } else {
                    tutorialVideo.onloadedmetadata = () => { // Ensure duration is captured
                        tutorialVideoDuration = tutorialVideo.duration;
                    };
                }
                sendGAEvent('tutorial_started', { 
                    event_category: GA_EVENT_CATEGORIES.TUTORIAL, 
                    video_url: tutorialVideo.currentSrc || '' 
                });
            }).catch(error => {
                console.warn("Tutorial video autoplay failed:", error);
                sendGAEvent('tutorial_autoplay_failed', { 
                    event_category: GA_EVENT_CATEGORIES.TUTORIAL, 
                    video_url: tutorialVideo.currentSrc || '', 
                    error_message: error.message 
                });
            });
        }

        function closeTutorial(closeReason = 'unknown', markAsSeen = true) {
            if (!tutorialModal.classList.contains('visible')) return; // Prevent multiple calls if already closing

            const watchedTime = tutorialVideo.currentTime;
            
            tutorialModal.classList.remove('visible');
            document.body.style.overflow = ''; // Restore scrolling
            tutorialVideo.pause();

            // Resume background videos if they were playing
            backgroundVideos.forEach(video => {
                 if (video && typeof video.play === 'function' && video.paused && video.dataset.wasPlaying === 'true') {
                    video.play().catch(e => console.warn("Resuming bg video failed", e));
                }
                delete video.dataset.wasPlaying; // Clean up
            });
            
            setTimeout(() => {
                tutorialModal.style.display = 'none';
            }, 500); // Match CSS transition duration

            if (markAsSeen) {
                try {
                    localStorage.setItem(tutorialStorageKey, 'true');
                    if (typeof gtag === 'function') {
                        gtag('set', 'user_properties', { 'has_completed_tutorial': 'true' });
                        // Assuming DEBUG_MODE is available or you have another way to log for debug
                        // if (DEBUG_MODE) {
                        //     console.log('[Tutorial - UserProp] Set has_completed_tutorial: true');
                        // }
                    }
                } catch (e) {
                    console.warn("Could not set localStorage for tutorial or send user property:", e);
                }
            }

            // Analytics
            if (tutorialCompletedNaturally) {
                sendGAEvent('tutorial_completed', {
                    event_category: GA_EVENT_CATEGORIES.TUTORIAL,
                    video_url: tutorialVideo.currentSrc || '',
                    video_duration: tutorialVideoDuration,
                    watched_time: tutorialVideoDuration // For completed, watched_time is full duration
                });
            } else {
                sendGAEvent('tutorial_skipped', {
                    event_category: GA_EVENT_CATEGORIES.TUTORIAL,
                    video_url: tutorialVideo.currentSrc || '',
                    close_reason: closeReason,
                    video_duration: tutorialVideoDuration,
                    watched_time: watchedTime
                });
            }
            tutorialCompletedNaturally = false; // Reset for next potential open
        }

        closeTutorialButton.addEventListener('click', () => closeTutorial('closed_by_button'));
        skipTutorialButton.addEventListener('click', () => closeTutorial('closed_by_skip_button'));
        tutorialModal.querySelector('.tutorial-backdrop').addEventListener('click', () => closeTutorial('closed_by_backdrop'));

        tutorialVideo.addEventListener('ended', () => {
            tutorialCompletedNaturally = true;
            closeTutorial('completed_naturally');
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && tutorialModal.classList.contains('visible')) {
                closeTutorial('closed_by_escape');
            }
        });

        // Check if tutorial should be shown
        try {
            if (localStorage.getItem(tutorialStorageKey) !== 'true') {
                setTimeout(openTutorial, 1000); // Show tutorial after 1 second
            }
        } catch (e) {
            console.warn("Could not access localStorage for tutorial:", e);
            // Fallback: show tutorial if localStorage is not accessible (e.g. private browsing)
            setTimeout(openTutorial, 1000);
        }


        // Insert logos into containers
        document.querySelectorAll('.menu-option').forEach(option => {
            const logoContainer = option.querySelector('.logo-container');
            const title = option.querySelector('.option-title').textContent.toLowerCase();
            if (logoContainer && title) {
                insertLogo(title, logoContainer);
            }
        });

        const clickSound = document.getElementById('clickSound');
        const hoverSound = document.getElementById('hoverSound');
        clickSound.volume = 0.25;
        hoverSound.volume = 0.3;

        // Preload sounds
        clickSound.load();
        hoverSound.load();

        // Check if device is mobile
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;

        // HLS initialization function
        function initializeHLS(video) {
            const src = video.querySelector('source')?.src;
            if (!src) return;

            // For browsers with native HLS support (Safari)
            if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = src;
                return;
            }

            // For other browsers, use HLS.js
            if (Hls.isSupported()) {
                const hls = new Hls({
                    maxBufferSize: 5 * 1000 * 1000,
                    maxBufferLength: 10,
                    enableWorker: true,
                    lowLatencyMode: false
                });

                hls.on(Hls.Events.ERROR, (event, data) => {
                    if (data.fatal) {
                        console.error('HLS fatal error:', data);
                        hls.destroy();
                    }
                });

                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;
            }
        }

        // Function to play video with fallback
        const playVideo = async (video) => {
            try {
                await video.play();
            } catch (err) {
                // If autoplay fails, try on first interaction
                const playOnInteraction = () => {
                    video.play().catch(() => {});
                    ['touchstart', 'click'].forEach(event => 
                        document.removeEventListener(event, playOnInteraction));
                };
                ['touchstart', 'click'].forEach(event => 
                    document.addEventListener(event, playOnInteraction, { once: true }));
            }
        };

        // Initialize HLS for tutorial video
        initializeHLS(tutorialVideo);

        // Handle all elements with videos
        document.querySelectorAll('.menu-option, .coming-soon').forEach(element => {
            const video = element.querySelector('video');
            if (!video) return;

            backgroundVideos.push(video); // Store reference for tutorial interaction
            
            // Initialize HLS for this video
            initializeHLS(video);
            
            // Set video properties
            video.classList.add('loading');
            video.loop = true;
            video.muted = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            
            video.addEventListener('loadeddata', () => {
                video.classList.remove('loading');
                if (isMobile) {
                    playVideo(video);
                } else {
                    video.currentTime = 0;
                    video.pause();
                }
            });

            video.addEventListener('error', () => {
                video.classList.remove('loading');
                console.log('Video error:', video.error);
            });
            
            if (!isMobile) {
                // Desktop hover handlers
                element.addEventListener('pointerenter', () => {
                    // Only play if tutorial is not visible
                    if (!tutorialModal.classList.contains('visible')) {
                        video.dataset.wasPlaying = 'true'; // Mark that it should resume
                        video.play().catch(() => {
                            video.classList.remove('loading');
                        });
                    }
                    hoverSound.currentTime = 0;
                    hoverSound.play().catch(() => {});
                });
                
                element.addEventListener('pointerleave', () => {
                    if (!video.paused) { // Only pause if it was actually playing
                       video.pause();
                    }
                     // Don't delete wasPlaying here, tutorial might close and need it
                });
            }

            // Handle click/touch for menu options
            if (element.classList.contains('menu-option')) {
                const handler = (e) => {
                    if (e.type === 'touchend') {
                        e.preventDefault();
                    }
                    clickSound.currentTime = 0;
                    clickSound.play().catch(() => {});
                    element.classList.add('clicked');
                    const title = element.querySelector('.option-title').textContent.toLowerCase();
                    sendGAEvent('menu_option_clicked', {
                        event_category: GA_EVENT_CATEGORIES.NAVIGATION,
                        event_label: 'Main Menu Navigation',
                        selected_tool: title
                    });
                    setTimeout(() => {
                        window.location.href = `/dashboard?mode=${title}`;
                    }, 1500);
                };

                element.addEventListener(isMobile ? 'touchend' : 'click', handler);
            }
        });

        // Ensure videos play after any user interaction
        if (isMobile) {
            const ensurePlayback = () => {
                document.querySelectorAll('video').forEach(video => {
                    if (video.paused) {
                        playVideo(video);
                    }
                });
            };
            ['touchstart', 'click'].forEach(event => 
                document.addEventListener(event, ensurePlayback, { once: true }));
        }

        // Dynamic Sparkle Effect for Ribbon
        const ribbonContent = document.querySelector('.ribbon__content');
        if (ribbonContent) {
            setInterval(() => {
                const sparkle = document.createElement('span');
                sparkle.classList.add('sparkle');
                
                const size = Math.random() * 4 + 2; // size between 2px and 6px
                sparkle.style.width = `${size}px`;
                sparkle.style.height = `${size}px`;
                
                // Start position somewhere on the ribbon
                sparkle.style.left = `${Math.random() * 100}%`;
                sparkle.style.top = `${Math.random() * 100}%`;
                
                // Random end position and duration
                const animDuration = Math.random() * 2 + 1; // 1s to 3s
                sparkle.style.setProperty('--x-end', `${(Math.random() - 0.5) * 100}px`);
                sparkle.style.setProperty('--y-end', `${(Math.random() - 0.5) * 100}px`);
                sparkle.style.animationDuration = `${animDuration}s`;

                ribbonContent.appendChild(sparkle);
                
                // Remove sparkle after animation
                setTimeout(() => {
                    sparkle.remove();
                }, animDuration * 1000);

            }, 200); // Create a new sparkle every 200ms
        }
    